import $ from 'jquery';
import Modernizr from 'modernizr';
import 'jquery-migrate/dist/jquery-migrate';
import './modules/_skip-link-focus-fix';
import './modules/_foundation-scripts';
import './modules/_mobile-menu';
import './modules/_forms';
import './modules/_social-popup';
import './modules/_scroll-back-to-top';
import './modules/_menus';
import './modules/_banner-video';
import 'jquery-match-height';
import 'slick-carousel/slick/slick.min.js';

/**
 * Notes:
 *
 * Although jQuery is imported above, it is not bundled
 * with the transpiled assets. jQuery needs to be global
 * on the website.
 *
 * All imports belong at the top of the file.
 *
 * Webpack only outputs this one script file, if you need
 * another file then add it to the scripts-list.js file as
 * another line in the scripts_list object.
 *
 * The scripts_list const is imported into the webpack
 * config. I've done this so that you do not have to
 * wade through the config to find what is being
 * compiled out as its own file.
 *
 * When importing node modules that are not ES6 modules,
 * you do not need to path them as '../../node_modules/'.
 * Gulp knows about the node_modules directory, so all you need
 * to do is path them as if you were already in the node_modules
 * directory
 *
 * Instead of:
 * import '../../node_modules/jquery-migrate/dist/jquery-migrate';
 *
 * Use:
 * import 'jquery-migrate/dist/jquery-migrate';
 *
 */

/*************** SVG image replacement ***************/
if(!Modernizr.svg) {
  $('img[src*="svg"]').attr('src', function() {
    return $(this).attr('src').replace('.svg', '.png');
  });
}

/*************** Template part region toggle button ***************/
$('.regions').click(function(event){
  event.preventDefault();

  $('.placeHolderPosition').slideToggle();
});

/*************** Flex Video ***************/
$('iframe[src*="player.vimeo.com"],[src*="www.youtube.com"],object[id="flashObj"]').each(function() {
  if (!$(this).parent().hasClass('flex-video')) {
    $(this).wrap('<div class="flex-video widescreen"/>');
  }
});

/*************** Match Height ***************/
$('.match-height').matchHeight();

/*************** External Menu Links ***************/
$('#quick_links_js, #main_menu_js, #site_footer_js').find('a').each((index, item)  => {
  const url = $(item).attr('href');
  const current_host = window.location.host;

  // Scheme/Protocol/Userinfo/Password/Authority/Port/Subdomain/Domain/TLD/Resource/Directory/Path/File Name/File Suffix/Query String/Hash/
  const url_array = url.toString().split(/(?:([^:]*):\/\/)?(?:([^:@]*)(?::([^@]*))?@)?(?:([^\\:]*)\.(?=[^.\\:]*\.[^.\\:]*))?([^.\\:]*)(?:\.([^\\.:]*))?(?::([0-9]*))?(\/[^?#]*(?=.*?\/)\/)?([^?#]*)?(?:\?([^#]*))?(?:#(.*))?/);

  if (url_array[1]) {
    url_array[5] !== current_host ? $(item).attr('target', '_blank') : '';
  }
});

/*************** Front Page LCN Current Link ***************/
const lcn_items = $('#lcn_items').find('.item');
const lcn_current_button = $('#lcn_current_issue');

$.each(lcn_items, function(index, item) {
  if (index === 0) {
    const link = $(item).attr('href');

    const link_array = link.split('/');
    const current_issue_link = `/${link_array[1]}/${link_array[2]}/${link_array[3]}`;

    $(lcn_current_button).attr('href', current_issue_link);
  }
});

/*************** Slick JS ***************/
$('#banner_rotator_js').show().slick({
  autoplay: true,
  autoplaySpeed: 5000,
  speed: 1000,
});

/*********** Footer Form reCAPTCHA ***********/
$('.footer-form').find('.form-item-captcha').addClass('medium-12');
$('.footer-form').find('.form-item-captcha').addClass('column');
